import { onDocumentLoaded } from "../utils/on-document-loaded.js";

onDocumentLoaded(() => {
    console.log("[sales-kassa-page.js inited]");

    /*mosaicSlider();*/
});
